"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _makeMethod = require("@/api/goods/makeMethod");
var _sortablejs = require("sortablejs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'makeMethodManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        typeId: null
      },
      types: [],
      editEquityVisible: false,
      editForm: {
        id: null,
        methodName: '',
        methodNameEn: '',
        sort: 0
      }
    };
  },
  created: function created() {
    this.getList();
    this.getTypes();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    getTypes: function getTypes() {
      var _this = this;
      (0, _makeMethod.queryTypeList)({
        page: 1,
        limit: 1000
      }).then(function (res) {
        if (res) {
          _this.types = res.records;
        }
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _makeMethod.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this2.dataList = response.records;
          _this2.total = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    openEquitiesDialog: function openEquitiesDialog(row) {
      var _this3 = this;
      (0, _makeMethod.getById)(row.id).then(function (res) {
        _this3.editForm = res.data;
      });
      this.editEquityVisible = true;
    },
    equitiesDialogClose: function equitiesDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    saveEquity: function saveEquity() {
      var _this4 = this;
      this.$refs.editFormRef.validate(function (valid) {
        if (valid) {
          (0, _makeMethod.update)(_this4.editForm).then(function () {
            _this4.$message.success('编辑成功');
            _this4.editEquityVisible = false;
            _this4.getList();
          }).catch(function () {
            _this4.$message.error('保存失败');
          });
        }
      });
    }
  }
};